import React, { FC } from 'react'
import { Heading, Text } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import { brandColors } from 'shared/basicPalette'
import {
  useGenerateUserResetPasswordLinkUsingSecurityQuestionsMutation,
  useGetUserSecurityQuestionsQuery
} from 'front-end/src/pages/auth/reset-password/ResetPassword.codegen'
import { Alert, AlertIcon, AlertTitle, Spinner } from '@chakra-ui/react'
import { ResetPasswordViaSecurityQuestionsForm } from 'front-end/src/pages/auth/reset-password/ResetPasswordViaSecurityQuestionsForm'
import { WithResetPasswordViaSecurityQuestionsFormik } from 'front-end/src/pages/auth/reset-password/ResetPasswordViaSecurityQuestionsFormik'

export const ResetPasswordViaSecurityQuestions: FC<{
  accountName: string
}> = ({ accountName }) => {
  const { data, loading } = useGetUserSecurityQuestionsQuery({
    variables: {
      accountName
    }
  })

  const [generateUserResetPasswordLinkUsingSecurityQuestions] =
    useGenerateUserResetPasswordLinkUsingSecurityQuestionsMutation({
      onCompleted: (data) => {
        location.href = data.generateUserResetPasswordLinkUsingSecurityQuestions
      }
    })

  if (loading) {
    return <Spinner />
  }

  const handleSubmit = (formData) =>
    generateUserResetPasswordLinkUsingSecurityQuestions({
      variables: {
        accountName,
        questionAnswers: formData
      }
    })

  return (
    <>
      <Heading size="md">
        <Trans>Identity verification</Trans>
      </Heading>

      <Text py="12px" color={brandColors.grey['800']}>
        <Trans>
          We need to ask you few security question to make sure that’s you. You
          answered these question on your sign-in process.
        </Trans>
      </Text>

      {data.getUserSecurityQuestions.length === 0 && (
        <Alert status="error" flexWrap={['wrap', 'initial']} mt="12px">
          <AlertIcon />
          <AlertTitle mr={2}>
            <Trans>
              No security questions are assigned to this account name.
            </Trans>
          </AlertTitle>
        </Alert>
      )}

      {data.getUserSecurityQuestions.length > 0 && (
        <WithResetPasswordViaSecurityQuestionsFormik
          onSubmit={handleSubmit}
          questions={data.getUserSecurityQuestions}
        >
          <ResetPasswordViaSecurityQuestionsForm />
        </WithResetPasswordViaSecurityQuestionsFormik>
      )}
    </>
  )
}
